import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import CreatePanModal from "./CreatePanModal";

const CreatePan = () => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <Button onClick={() => setModal(true)}>{t("Створити лоток")}</Button>
      <CreatePanModal open={modal} onCancel={() => setModal(false)} />
    </div>
  );
};

export default CreatePan;
